import { useGoogleLogin } from "@react-oauth/google";
import type { ICustomerQuery } from "@repo/shopify/src/queries/customer-gql";
import React from "react";
import { useTranslation } from "react-i18next";

import Button from "@components/atoms/Button";
import Icon from "@components/atoms/Icon";
import LoadingIcon from "@components/atoms/LoadingIcon";

import useSocialLogin from "@hooks/useSocialLogin";

import { IconName } from "@const/enum";

interface IProps {
  onComplete: (accessToken?: string, customer?: ICustomerQuery["customer"]) => void;
}

function GoogleLogin({ onComplete }: IProps) {
  const { t } = useTranslation();
  const { isProgressing, isLoading, setIsLoading, socialLogin } = useSocialLogin({ onComplete });

  const googleLogin = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      void socialLogin(`=google&google_token=${tokenResponse.access_token}`);
    },
  });

  return (
    <Button
      isLoading={isProgressing || isLoading}
      onClick={() => {
        if (isProgressing || isLoading) return;
        setIsLoading(true);
        googleLogin();
        setIsLoading(false);
      }}
      styleType="primary"
      variant="social"
    >
      <span className="flex w-full items-center justify-center gap-[8px]">
        <Icon alt="google" className="size-[14px]" name={IconName.Google} />
        <span>{t("login.google_continue")}</span>
      </span>
    </Button>
  );
}

export default GoogleLogin;
